module.exports = __webpack_public_path__ + "static/img/ongjin-pt.37a39f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/ongjin-pt.jpg
// module id = 73yU
// module chunks = 0